'POReceiptLine'.datatype()
'receiptNumber'.field({refersToParent: 'POReceipt', parentIsHeader: true})
'product'.field({refersTo: 'products', showAsLink: true})
'descriptionAndSKU'.field({caption: 'Description'})
'orderedQuantity'.field({numeric: true})
'receivedQuantity'.field({numeric: true})
'previouslyReceived'.field({numeric: true})
'cancelledQuantity'.field({numeric: true})
'outstandingQuantity'.field({numeric: true})
'poLine'.field({refersTo: 'POLine', caption: "PO Line"})
'supplierName'.field()
'unitCostFX'.field({numeric: true, minDecimals: 2, maxDecimals: 6, caption: "Unit Price (Inc Tax)"})
'unitCostExclTaxFX'.field({numeric: true, minDecimals: 2, maxDecimals: 6, caption: "Unit Price (Excl Tax)"})
'unitCost'.field({numeric: true, minDecimals: 2, maxDecimals: 6, caption: "Unit Price (Inc Tax)"})
'currency'.field({refersTo: 'Currency'})
'avgUnitCostIncludingThisOrder'.field({numeric: true, decimals: 2, caption: "Avg Unit Cost (including this Order)"})
'recommendedRetailPriceIncTax'.field({numeric: true, decimals: 2, caption: "Recommended Retail Price (inc Tax)"})
'recommendedRetailPriceExclTax'.field({numeric: true, decimals: 2})
'wooCommerceRegularPrice'.field({numeric: true, decimals: 2, caption: "WooCommerce Regular Price"})
'marginPct'.field({numeric: true, decimals: 2, caption: "Margin %"})
'barcode'.field()
'includeTaxOption'.field({yesOrNo: true})
'supplierSku'.field({caption: 'Supplier SKU'})
'taxPct'.field({caption: "Tax %"})
'unitCostIncTaxFXRounded'.field({numeric: true, decimals: 2, caption: "Unit Price (Inc Tax)"})
'lineCostIncTaxFX'.field({numeric: true, minDecimals: 2, maxDecimals: 6, caption: "Line Total (Inc Tax)"})
'sku'.field({caption: 'SKU'})
'hasLots'.field({yesOrNo: true})
'lotsAreSerials'.field({yesOrNo: true})
'orderedQuantityPU'.field({numeric: true, caption: 'Ordered Quantity'})
'receivedQuantityPU'.field({numeric: true, caption: 'Received Quantity'})
'previouslyReceivedPU'.field({numeric: true, caption: 'Previously Received'})
'cancelledQuantityPU'.field({numeric: true, caption: 'Cancelled Quantity'})
'outstandingQuantityPU'.field({numeric: true, caption: 'Outstanding Quantity'})
'uomDisplay'.field({caption: 'Unit of Measure'})
'uom'.field({refersTo: 'UOM', caption: 'Unit of Measure'})
'newQuantityOnHand'.field({numeric: true, caption: 'New QOH'})
'image'.field({postImage: true, postImageType: 'full', postIdField: 'product'})
'thumbnailImage'.field({postImage: true, postImageType: 'thumbnail', postIdField: 'product', caption: 'Image'})

'newQuantityOnHand'.calculate(async line => {
  let inv = await line.toInventory()
  let res = inv ? inv.quantityOnHand : 0
  res += line.receivedQuantity - line.getOld().receivedQuantity
  return res
})

'uomDisplay'.calculate(async line => {
  if ( line.uom ) {
    return line.uom.keyval
  }
  let c = 'Configuration'.bringSingleFast(); if ( ! c ) return ''
  let uom = await c.toDefaultStockingUOM(); if ( ! uom ) return ''
  return uom.uomName
})

'POReceiptLine'.method('refreshCancelledQuantity', async function() {
  let mult = await this.toQuantityPerPurchasingUOM()
  if ( ! mult ) mult = 1
  this.cancelledQuantity = this.cancelledQuantityPU * mult
})

'POReceiptLine'.method('refreshReceivedQuantityPU', async function() {
  this.receivedQuantityPU = await this.numberToPU(this.receivedQuantity)
})

'POReceiptLine'.method('refreshReceivedQuantity', async function() {
  let mult = await this.toQuantityPerPurchasingUOM()
  if ( ! mult ) mult = 1
  this.receivedQuantity = this.receivedQuantityPU * mult
})

'lotsAreSerials'.calculate(async recLine => {
  let inv = await recLine.toInventory(); if ( ! inv ) return 'No'
  let bres = inv.lotTracking === 'Serial'
  let res = bres ? 'Yes' : 'No'
  return res
})

'POReceiptLine'.method('toAllotments', async function() {
  return await 'Allotment'.bringChildrenOf(this)
})

'POReceiptLine'.method('toPOStatus', async function() {
  let po = await this.toPO(); if ( ! po ) return null
  return po.status
})

'POReceiptLine'.method('toCluster', async function() {
  let inv = await this.toInventory(); if ( ! inv ) return null
  let locRef = await this.toLocationRef(); if ( ! locRef ) return null
  let res = await inv.locationRefToCluster(locRef)
  return res
})

'POReceiptLine'.method('toLocationRef', async function() {
  let po = await this.toPO(); if ( ! po ) return null
  let res = po.location
  return res
})

'POReceiptLine'.method('toLocation', async function() {
  let po = await this.toPO(); if ( ! po ) return null
  let res = await po.toLocation()
  return res
})

'POReceiptLine'.method('toMainQuantity', async function() {
  return this.receivedQuantity
})

'POReceiptLine'.method('createAllotments', async function() {
  let poLine = await this.toPOLine(); if ( ! poLine ) return
  let allotments = await 'Allotment'.bringChildrenOf(poLine)
  for ( var i = 0; i < allotments.length; i++ ) {
    let poAllotment = allotments[i]
    let quantity = await poLine.allotmentToOutstandingQuantity(poAllotment)
    if ( quantity <= 0 )
      continue
    let thisRef = this.reference()
    let a = await 'Allotment'.create({parentCast: this}, {allotmentParent: thisRef})
    let lot = await poAllotment.toLot(); if ( ! lot ) continue
    a.lot = lot.reference()
    a.quantity = quantity
  }
})

'hasLots'.calculate(async recLine => {
  let inv = await recLine.toInventory(); if ( ! inv ) return 'No'
  let bres = inv.lotTracking && (inv.lotTracking !== 'None')
  let res = bres ? 'Yes' : 'No'
  return res
})

'POReceiptLine'.method('toSupplierRef', async function() {
  let rec = await this.toPOReceipt()
  return rec && rec.supplier
})

'POReceiptLine'.method('toReceivedDate', async function() {
  let rec = await this.toPOReceipt()
  return rec && rec.receivedDate
})

'sku'.calculate(async (recLine) => {
  let p = await recLine.toProduct(); if ( ! p ) return
  return p._sku
})

'supplierSku'.calculate(async (recLine) => {
  let res
  let inv = await recLine.toInventory(); if ( ! inv ) return res
  let suppRef = await recLine.toSupplierRef(); if ( ! suppRef ) return res
  return await inv.supplierRefToSKU(suppRef)
})

'taxPct'.calculate(async (recLine) => {
  let poLine = await recLine.toPOLine()
  return poLine && poLine.taxPct
})

'POReceiptLine'.afterCreating(async function () {
  let c = await 'Configuration'.bringFirst(); if ( ! c ) return
  this.includeTaxOption = c.enterPurchasePricesInclusiveOfTax
})

'barcode'.calculate(async line => {
  let av = await line.toAvenue(); if ( ! av ) return null
  return av.barcode
})

'unitCostExclTaxFX'.calculateWhen(async (line) => {
  return await line.enteredInclusiveOfTax()
})

'unitCostExclTaxFX'.calculate(async (line) => {
  let poLine = await line.toPOLine(); if ( ! poLine ) return 0
  let res = global.roundToXDecimals(line.unitCostFX / ( 1 + (poLine.taxPct / 100)), 6)
  return res
})

'unitCostFX'.calculateWhen(async (line) => {
  return await line.enteredExclusiveOfTax()
})

'unitCostFX'.calculate(async (line) => {
  let poLine = await line.toPOLine(); if ( ! poLine ) return 0
  let res = global.roundToXDecimals(line.unitCostExclTaxFX * (1 + (poLine.taxPct / 100)), 6)
  return res
})

'unitCost'.calculate(async line => {
  let exchangeRate = await line.toExchangeRate()
  if ( ! exchangeRate )
    exchangeRate = 1
  let res = line.unitCostFX / exchangeRate
  return res
})

'POReceiptLine'.method('toPOLine', async function() {
  return await this.referee('poLine')
})

'POReceiptLine'.method('toExchangeRate', async function() {
  let res = 1
  let rec = await this.toPOReceipt(); if ( ! rec ) return res
  res = rec.exchangeRate
  if ( ! res )
    res = 1
  return res
})

'POReceiptLine'.method('toPOReceipt', async function() {
  return await this.referee('receiptNumber')
})

'currency'.calculate(async line => {
  let po = await line.toPO(); if ( ! po ) return null
  return po.currency
})

'avgUnitCostIncludingThisOrder'.calculate(async line => {
  let inv = await line.toInventory()
  let prodQty = inv ? inv.quantityOnHand : 0
  let prodAvg = inv ? inv.avgUnitCost : 0
  if ( (prodAvg === global.unknownNumber()) && (prodQty !== 0) )
    return global.unknownNumber()
  let prodTotalValue = prodQty * prodAvg
  prodQty -= line.getOld().receivedQuantity
  prodTotalValue -= (line.getOld().receivedQuantity * line.getOld().unitCost)
  if ( prodQty !== 0 )
    prodAvg = prodTotalValue / prodQty
  let remainingQuantity = line.orderedQuantity - line.cancelledQuantity
  let totalQty = prodQty + remainingQuantity
  if ( ! totalQty ) return 0
  let res = ((prodAvg * prodQty) + (line.unitCost * remainingQuantity)) / totalQty
  return res
})

'marginPct'.calculate(async line => {
  let avgUnitCost = line.avgUnitCostIncludingThisOrder; if ( avgUnitCost === global.unknownNumber() ) return 0
  let regularPrice = line.wooCommerceRegularPrice; if ( ! regularPrice ) return 0
  let marginValue = regularPrice - avgUnitCost
  let res = (marginValue / regularPrice) * 100
  return res
})

'supplierName'.calculate(async receiptLine => {
  let supplier = await receiptLine.toSupplier(); if ( ! supplier ) return null
  return supplier.name
})

'recommendedRetailPriceExclTax'.calculate(async receiptLine => {
  let avenue = await receiptLine.toAvenue(); if ( ! avenue ) return null
  return avenue.recommendedRetailPriceExclTax
})

'descriptionAndSKU'.calculate(async receiptLine => {
  let poLine = await receiptLine.referee('poLine'); if ( ! poLine ) return null
  return poLine.descriptionAndSKU
})

'orderedQuantity'.calculate(async (recLine) => {
  let poLine = await recLine.referee('poLine'); if ( ! poLine ) return 0
  return poLine.quantity
})

'previouslyReceived'.calculate(async (recLine) => {
  let res = 0
  let otherRecLines = await 'POReceiptLine'.bring({poLine: recLine.poLine})
  otherRecLines.forAll(rl => {
    if ( rl.id === recLine.id ) return 'continue'
    res = res + rl.receivedQuantity
  })
  return res
})

'outstandingQuantity'.calculate(async (recLine) => {
  let res = recLine.orderedQuantity - recLine.previouslyReceived - recLine.receivedQuantity - recLine.cancelledQuantity
  if ( res < 0 )
    res = 0
  return res
})

'POReceiptLine'.method('toQuantityPerPurchasingUOM', async function(num) {
  let inv = await this.toInventory(); if ( ! inv ) return 1
  return inv.quantityPerPurchasingUOM
})

'POReceiptLine'.method('numberToPU', async function(num) {
  let div = await this.toQuantityPerPurchasingUOM()
  if ( ! div ) return num
  return num / div
})

'orderedQuantityPU'.calculate(async (recLine) => {
  return await recLine.numberToPU(recLine.orderedQuantity)
})

'previouslyReceivedPU'.calculate(async (recLine) => {
  return await recLine.numberToPU(recLine.previouslyReceived)
})

'outstandingQuantityPU'.calculate(async (recLine) => {
  return await recLine.numberToPU(recLine.outstandingQuantity)
})

'POReceiptLine'.method('toPO', async function() {
  let poLine = await this.referee('poLine'); if ( ! poLine ) return null
  return await poLine.toPO()
})

'POReceiptLine'.method('toSupplier', async function() {
  let po = await this.toPO(); if ( ! po ) return null
  return await po.toSupplier()
})

'POReceiptLine'.method('toAvenue', async function() {
  let poLine = await this.referee('poLine'); if ( ! poLine ) return null
  let res = await poLine.toAvenue()
  return res
})

'POReceiptLine'.method('checkLotQuantities', async function() {
  let qty = 0
  let allotments = await 'Allotment'.bringChildrenOf(this)
  for ( var i = 0; i < allotments.length; i++ ) {
    let a = allotments[i]
    qty += a.quantity
  }
  if ( qty !== this.receivedQuantity ) {
    let msg
    if ( this.lotsAreSerials === 'Yes' )
      msg = 'Quantity of Serial Numbers'.translate() + ' (' + qty + ') ' + 'does not match the quantity received'.translate() + ' (' + this.receivedQuantity + ')'
    else
      msg = 'Lot quantity total'.translate() + ' (' + qty + ') ' + 'does not match the quantity received'.translate() + ' (' + this.receivedQuantity + ')'
    throw(new Error(msg))
  }
})

'POReceiptLine'.method('createTransaction', async function(chg) {
  let c = await 'Configuration'.bringOrCreate();
  if ( c.suppressPOQuantityOnHandUpdates === 'Yes' )
    return
  let po = await this.getPO(); if ( ! po ) return
  let tran = await 'Transaction'.create()
  let newExtCost = this.receivedQuantity * this.unitCost
  let oldExtCost = this.getOld().receivedQuantity * this.getOld().unitCost
  let extCostChg = newExtCost - oldExtCost
  let receipt = await this.parent()
  tran.product = this.product
  tran.date = receipt.receivedDate
  tran.quantity = chg
  tran.unitCost = (chg === 0) ? 0 : extCostChg / chg
  tran.source = 'PO Receipt'
  tran.reference = po.purchaseOrderNumber
  tran.location = global.copyObj(po.location)
  tran.taxPct = this.taxPct
})

'POReceiptLine'.method('createTransactionForAllotment', async function(a) {
  let c = await 'Configuration'.bringOrCreate();
  if ( c.suppressPOQuantityOnHandUpdates === 'Yes' )
    return
  let po = await this.getPO(); if ( ! po ) return
  let chg = a.quantity - a.getOld().quantity
  if ( chg === 0 )
    return
  let tran = await 'Transaction'.create()
  let newExtCost = a.quantity * this.unitCost
  let oldExtCost = a.getOld().quantity * this.getOld().unitCost
  let extCostChg = newExtCost - oldExtCost
  let receipt = await this.parent()
  tran.product = this.product
  tran.date = receipt.receivedDate
  tran.quantity = chg
  tran.unitCost = (chg === 0) ? 0 : extCostChg / chg
  tran.source = 'PO Receipt'
  tran.reference = po.purchaseOrderNumber
  tran.location = global.copyObj(po.location)
  tran.lot = global.copyObj(a.lot)
  tran.taxPct = this.taxPct
})

'POReceiptLine'.beforeSaving(async function() {
  if ( this.hasLots === 'Yes' ) 
    await this.checkLotQuantities()
  let unreceived = this.orderedQuantity - this.previouslyReceived - this.receivedQuantity
  if ( this.propChanged('cancelledQuantity') ) {
    if ( this.orderedQuantity >= 0 ) {
      if ( unreceived < 0 ) unreceived = 0
      if ( this.cancelledQuantity > unreceived ) throw(new Error('You cannot cancel more than the quantity left on order (' + this.descriptionAndSKU + ')'))
    } else {
      if ( unreceived > 0 ) unreceived = 0
      if ( this.cancelledQuantity < unreceived ) throw(new Error('You cannot cancel more than the quantity left on order' + this.descriptionAndSKU + ')'))
    }
  }
  let poLine = await this.getPOLine()
  let chg = this.receivedQuantity - this.getOld().receivedQuantity
  let cchg = this.cancelledQuantity - this.getOld().cancelledQuantity
  if ( ! poLine._markedForDeletion ) {
    poLine.receivedQuantity = poLine.receivedQuantity + chg
    poLine.cancelledQuantity = poLine.cancelledQuantity + cchg
  }
  let po = await this.getPO(); if ( ! po ) return
  await po.refreshStatus()
  if ( this.hasLots !== 'Yes' ) { // otherwise created in beforeSaving of Allotment
    if ( (chg !== 0) && ((! poLine.lineType) || (poLine.lineType === "Product")) )
      await this.createTransaction(chg)
  }
  if ( ! this._markedForDeletion ) {
    poLine.unitCostIncTaxFX = this.unitCostFX
    poLine.unitCostExclTaxFX = this.unitCostExclTaxFX
    poLine.recommendedRetailPriceIncTax = this.recommendedRetailPriceIncTax
    poLine.wooCommerceRegularPrice = this.wooCommerceRegularPrice
/*
    if ( this.receivedQuantity > 0 ) {
      let inv = await this.toInventory()
      if ( inv ) {
        let receivedDate = await this.toReceivedDate()
        if ( (receivedDate >= inv.lastReceivedDate) || (! inv.lastReceivedDate) ) {
          inv.lastReceivedDate = receivedDate
        }
      }
    }
*/
  }
  let inv = await this.toInventory()
  if ( inv ) {
    await inv.refreshLastReceivedDate()
  }
})

'POReceiptLine'.method('getPO',
  async function () {
    let receipt = await this.parent(); if ( ! receipt ) return null
    let res = await receipt.referee('purchaseOrder')
    return res
  }
)

'POReceiptLine'.method('getPOLine',
  async function () {
    let res = await this.referee('poLine')
    return res
  }
)

'POReceiptLine'.method('toProduct', async function() {
  return await this.referee('product')
})

'POReceiptLine'.method('toInventory', async function() {
  let product = await this.toProduct(); if ( ! product ) return null
  return await product.toInventory()
})

'POReceiptLine'.method('maybeInitFXFields', async function() {
  let thisIsFromOldVersion = this.unitCost && (! this.unitCostFX)
  if ( thisIsFromOldVersion )
    this.unitCostFX = this.unitCost
})

'POReceiptLine'.afterRetrieving(async function() {
  await this.refreshDependentFields()
})

'POReceiptLine'.method('refreshDependentFields', async function() {
  await this.maybeInitFXFields()
  this.recommendedRetailPriceIncTax = 0
  this.wooCommerceRegularPrice = 0
  this.unitCostFX = 0
  this.unitCostExclTaxFX = 0
  let poLine = await this.getPOLine(); if ( ! poLine ) return
  this.unitCostFX = poLine.unitCostIncTaxFX
  this.unitCostExclTaxFX = poLine.unitCostExclTaxFX
  let product = await this.toProduct(); if ( ! product ) return
  this.wooCommerceRegularPrice = product._regular_price
  let avenue = await this.toAvenue(); if ( ! avenue ) return
  this.recommendedRetailPriceIncTax = avenue.recommendedRetailPriceIncTax
})

'POReceiptLine'.method('enteredExclusiveOfTax', async function () {
  return this.includeTaxOption === "No"
})

'POReceiptLine'.method('enteredInclusiveOfTax', async function () {
  return this.includeTaxOption !== "No"
})

'POReceiptLine'.method('calcLineCostIncTaxFX', async function () {
  let res = global.roundTo2Decimals(this.unitCostFX * this.receivedQuantity)
  return res
})

'POReceiptLine'.method('calcLineCostExclTaxFX', async function () {
  let res = global.roundTo2Decimals(this.unitCostExclTaxFX * this.receivedQuantity)
  return res
})

'lineCostIncTaxFX'.calculate(async (recLine) => {
  let res = await recLine.calcLineCostIncTaxFX()
  return res
})

'unitCostIncTaxFXRounded'.calculate(async (recLine) => {
  return recLine.unitCostFX
})

